import { render, staticRenderFns } from "./ForgotPasswordConfirmation.vue?vue&type=template&id=f3ffde8e&scoped=true"
import script from "./ForgotPasswordConfirmation.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordConfirmation.vue?vue&type=style&index=0&id=f3ffde8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ffde8e",
  null
  
)

export default component.exports